import { useState } from "react";

import AskAI from "@apps/ask-ai/ask-ai";
import { ChatSessionContext } from "@apps/ask-ai/ask-ai-context";
import { currentOrganizationVar } from "@cache/cache";
import Layout from "@components/layout/layout";

import ProfilePageSidebar from "../profile-page-sidebar";

// The Summary tab pairs with a global Ask AI sidebar. When Ask AI isn't
// available for the org we fall back to the regular profile Details sidebar so
// the panel is never empty.
const ProfileSummarySidebar = ({ profileId }: { profileId: number }) => {
  const organization = currentOrganizationVar();
  const askAiEnabled = !!organization.featureFlags.askAi;

  const [askAIChatSessionId, setAskAIChatSessionId] = useState<null | number>(
    null,
  );
  const [startedChatSession, setStartedChatSession] = useState(false);

  if (!askAiEnabled) {
    return <ProfilePageSidebar profileId={profileId} />;
  }

  return (
    <Layout.Sidebar<string>
      tabs={[{ value: "ask-ai", title: "Ask AI", active: true }]}
      onChangeTab={() => {}}
      sidebarExpandedUiPreferenceKey="profileSidebarExpanded"
      fullHeight
    >
      <ChatSessionContext.Provider value={{}}>
        <AskAI
          isInSidebar
          chatSessionId={askAIChatSessionId}
          onChangeChatSessionId={setAskAIChatSessionId}
          isFullScreen={!!askAIChatSessionId || startedChatSession}
          className="px-6 pb-6"
          totalYPaddingAroundContainer={110}
          showChatHistory
          onStartChatSession={() => setStartedChatSession(true)}
        />
      </ChatSessionContext.Provider>
    </Layout.Sidebar>
  );
};

export default ProfileSummarySidebar;
